// ヘッダー追従式
document.addEventListener("DOMContentLoaded", function() {
  // ヘッダー要素の取得
  const header = document.querySelector('.tirol-header');
  const spHeader = document.querySelector('.sp-tirol-header');

  // ヘッダーの高さを取得してトップマージンを設定する関数
  function adjustBodyMargin() {
    let headerHeight = header.offsetHeight;
    let spHeaderHeight = spHeader.offsetHeight;

    // 画面幅によって異なるヘッダーの高さを考慮
    if (window.innerWidth <= 1100) {
      document.body.style.marginTop = spHeaderHeight + 'px';
    } else {
      document.body.style.marginTop = headerHeight + 'px';
    }
  }

  // 初期設定
  adjustBodyMargin();

  // ウィンドウリサイズ時に再度マージンを調整
  window.addEventListener('resize', adjustBodyMargin);
});

// ページTOPへ戻るボタン
const pagetop_btns = document.querySelectorAll(".to-top-btn, .sp-to-top-btn");

// ボタンが存在する場合のみイベントリスナーを追加
if (pagetop_btns.length > 0) {
  pagetop_btns.forEach(btn => {
    // .to-top-btnをクリックしたら
    btn.addEventListener("click", scroll_top);
  });

  // ページ上部へスムーズに移動
  function scroll_top() {
    window.scroll({ top: 0, behavior: "smooth" });
  }

  // スクロールされたら表示
  window.addEventListener("scroll", scroll_event);
  function scroll_event() {
    pagetop_btns.forEach(btn => {
      if (window.pageYOffset > 100) {
        btn.style.opacity = "1";
      } else {
        btn.style.opacity = "0";
      }
    });
  }
} else {
  console.error("`.to-top-btn`または`.sp-to-top-btn`が見つかりませんでした。");
}

// ハンバーガーメニュー
document.querySelectorAll('.hamb-btn').forEach(function(button) {
  button.addEventListener('click', function() {
      button.classList.toggle('active');
  });
});

document.querySelector('.hamb-btn').addEventListener('click', function() {
  var menu = document.querySelector('.hamb-menu');
  var body = document.body;
  
  menu.classList.toggle('open');
  body.classList.toggle('no_scroll');
});

// LINE登録ボタン
// document.addEventListener('DOMContentLoaded', function() {
//   // ページがロードされてから3秒後に .tirol-line-pop-wrap を表示
//   setTimeout(function() {
//     document.querySelector('.tirol-line-pop-wrap').classList.add('show');
//   }, 3000);

//   // .tirol-line-pop__friend-add-del をクリックしたときに .tirol-line-pop-wrap を非表示にする
//   document.querySelector('.tirol-line-pop__friend-add-del').addEventListener('click', function(event) {
//     event.preventDefault(); // デフォルトの動作を防ぐ
//     document.querySelector('.tirol-line-pop-wrap').classList.remove('show');
//   });
// });
document.addEventListener('DOMContentLoaded', function() {
  // localStorageから非表示にするべきかどうかをチェック
  const hideUntil = localStorage.getItem('hideUntil');
  const now = new Date().getTime();

  if (hideUntil && now < hideUntil) {
    // まだ24時間経っていない場合は表示しない
    return;
  }

  // ページがロードされてから3秒後に .tirol-line-pop-wrap を表示
  setTimeout(function() {
    document.querySelector('.tirol-line-pop-wrap').classList.add('show');
  }, 3000);

  // .tirol-line-pop__friend-add-del をクリックしたときに .tirol-line-pop-wrap を非表示にする
  document.querySelector('.tirol-line-pop__friend-add-del').addEventListener('click', function(event) {
    event.preventDefault(); // デフォルトの動作を防ぐ
    document.querySelector('.tirol-line-pop-wrap').classList.remove('show');
    
    // 24時間後のタイムスタンプを計算し、localStorageに保存
    const hideUntilTime = now + 24 * 60 * 60 * 1000; // 24時間後
    localStorage.setItem('hideUntil', hideUntilTime);
  });
});

// Bボタン　スムーススクロール
document.querySelector('.tirol-b-btn').addEventListener('click', function() {
  const targetElement = document.querySelector('.sp-tirol-find__btn-container01');

  if (targetElement) {
    const startPosition = window.scrollY;
    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    const distance = elementPosition - startPosition + 70;
    const duration = 1000; // スクロールにかける時間を1秒（1000ミリ秒）に設定
    let startTime = null;

    function scrollAnimation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(scrollAnimation);
    }

    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(scrollAnimation);
  }
});document.querySelector('.tirol-b-btn').addEventListener('click', function() {
  const targetElement = document.querySelector('.sp-tirol-find__btn-container01');

  if (targetElement) {
    const startPosition = window.scrollY;
    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    const distance = elementPosition - startPosition + 70;
    const duration = 1000; // スクロールにかける時間を1秒（1000ミリ秒）に設定
    let startTime = null;

    function scrollAnimation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(scrollAnimation);
    }

    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(scrollAnimation);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.tirol-ranking__container-item');

  items.forEach(item => {
    item.addEventListener('mouseenter', function() {
      const plusBtn = this.querySelector('.tirol-ranking__plus-btn-wrap');
      plusBtn.style.opacity = '1';
      plusBtn.style.transform = 'translateX(-50%) translateY(0)';
    });

    item.addEventListener('mouseleave', function() {
      const plusBtn = this.querySelector('.tirol-ranking__plus-btn-wrap');
      plusBtn.style.opacity = '0';
      plusBtn.style.transform = 'translateX(-50%) translateY(100%)';
    });
  });
});

// 商品詳細、もっと見るボタン
document.addEventListener('DOMContentLoaded', function() {
  var moreBtn = document.getElementById('desc-more-btn');
  var moreText = document.getElementById('desc-more-btn__text');

  if (moreBtn) {
      moreBtn.addEventListener('click', function() {
          console.log('Button clicked!');
          moreText.classList.toggle('open');
          console.log(moreText.classList);
      });
  } else {
      console.log('desc-more-btn not found');
  }
});